import { useEffect, useState } from "react";
import { getQueue, flushQueue } from "@/lib/offlineQueue";
import { WifiOff, Wifi, RefreshCw } from "lucide-react";

export default function OfflineBadge() {
  const [online, setOnline] = useState(typeof navigator !== "undefined" ? navigator.onLine : true);
  const [queue, setQueue] = useState([]);
  const [syncing, setSyncing] = useState(false);

  const refresh = async () => setQueue(await getQueue());
  useEffect(() => {
    const on = () => setOnline(true);
    const off = () => setOnline(false);
    window.addEventListener("online", on);
    window.addEventListener("offline", off);
    window.addEventListener("icos-offline-queue-changed", refresh);
    refresh();
    return () => {
      window.removeEventListener("online", on);
      window.removeEventListener("offline", off);
      window.removeEventListener("icos-offline-queue-changed", refresh);
    };
  }, []);

  const sync = async () => { setSyncing(true); await flushQueue(); await refresh(); setSyncing(false); };

  if (online && queue.length === 0) return null;

  return (
    <div data-testid="offline-badge" className={`flex items-center gap-2 border px-3 py-2 text-xs ${online ? "border-amber-400 bg-amber-50" : "border-red-400 bg-red-50"}`}>
      {online ? <Wifi size={14} /> : <WifiOff size={14} />}
      <span className="font-mono">
        {online ? `${queue.length} queued` : `Offline · ${queue.length} queued`}
      </span>
      {online && queue.length > 0 && (
        <button data-testid="sync-now" onClick={sync} disabled={syncing} className="ml-2 border border-slate-300 px-2 py-1 flex items-center gap-1 hover:bg-slate-900 hover:text-white disabled:opacity-50">
          <RefreshCw size={12} className={syncing ? "animate-spin" : ""} /> Sync now
        </button>
      )}
    </div>
  );
}
